import { forwardRef } from 'react';
import { StyledOl } from './styled';

const Ol = forwardRef((props, ref) => <StyledOl ref={ref} {...props} />);

export default Ol;
